module.exports = __webpack_public_path__ + "media/mâi kâo jai.1fa880cb.mp3";